function handleRemoveProductTbh(index, setInputs, showProduct, setShowProduct) {
  setInputs((prevInputs) => {
    const newProductTbh = prevInputs.product_tbh.filter((_, i) => i !== index);

    return {
      ...prevInputs,
      product_tbh: newProductTbh,
    };
  });
  if (showProduct === index) {
    setShowProduct(null);
  }
}

export default handleRemoveProductTbh;
